import { Row } from "@tanstack/react-table";
import { RefObject } from "react";

import { IsRowDragDisabledFn } from "../reorder";
import { RowSelectionConditions } from "../selection";
import { TableData } from "../table";
import { OnRowClickFn } from "../table.types";
import { TableRow } from "./table_row";

type TableBodyProps<TABLE_DATA extends TableData> = {
  rows: Row<TABLE_DATA>[];
  onRowClick?: OnRowClickFn<TABLE_DATA>;
  getRowClassName?: (row: Row<TABLE_DATA>, rowIndex: number) => string | undefined;
  compact?: boolean;
  noHover?: boolean;
  displayGrid?: boolean;
  topAlignContent?: boolean;
  lastRowRef: React.RefObject<HTMLTableRowElement | null> | undefined;
  renderExpandedRow?: (row: TABLE_DATA) => React.ReactNode;
  rowSelectionConditions?: RowSelectionConditions<TABLE_DATA>;
  scrollableContainerRef?: RefObject<HTMLElement | null>;
  hideDistantRows?: boolean;
  isInteractive?: boolean;
  enableRowReordering?: boolean;
  isRowDragDisabled?: IsRowDragDisabledFn<TABLE_DATA>;
};

export const TableBody = <TABLE_DATA extends TableData>({
  rows,
  onRowClick,
  getRowClassName,
  compact,
  topAlignContent,
  noHover,
  displayGrid,
  lastRowRef,
  renderExpandedRow,
  rowSelectionConditions,
  scrollableContainerRef,
  hideDistantRows,
  isInteractive,
  enableRowReordering,
  isRowDragDisabled
}: TableBodyProps<TABLE_DATA>) => (
  <tbody>
    {rows.map((row, index) => (
      <TableRow
        key={row.id}
        row={row}
        rowIndex={index}
        onRowClick={onRowClick}
        getRowClassName={getRowClassName}
        compact={compact}
        topAlignContent={topAlignContent}
        noHover={noHover}
        displayGrid={displayGrid}
        lastRowRef={rows.length - 1 === index ? lastRowRef : undefined}
        renderExpandedRow={renderExpandedRow}
        rowSelectionConditions={rowSelectionConditions}
        scrollableContainerRef={scrollableContainerRef}
        hideDistantRows={hideDistantRows}
        isInteractive={isInteractive}
        enableRowReordering={enableRowReordering}
        isRowDragDisabled={isRowDragDisabled}
      />
    ))}
  </tbody>
);
